
import {
  bgGreenHeader,
  bgRedHeader,
  bgBlueheader,
  bgGreyheader,
} from "./styles";


/**
 * Obtener fecha actual
 */
export const getCurrentDate = (separator) => {
  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  return `${date}${separator}${
    month < 10 ? `0${month}` : `${month}`
  }${separator}${year}`;
};

/**
 *
 * Para calcular la fecha del datapicker
 */
export const getFinishMaxDate = (e, mesesMaxs) => {
  //Si cambia la fecha de inicio. fin es inicio - 3 meses
  if (e === null || e === undefined) {
    return null;
  }
  let mesesMax = mesesMaxs || 3;

  let dia = e.getDate() < 10 ? "0" + e.getDate() : e.getDate();
  let mes = e.getMonth() + 1 < 10 ? "0" + (e.getMonth() + 1) : e.getMonth() + 1;
  let año = e.getFullYear();
  let fechaFinNueva = new Date(año + "/" + mes + "/" + dia);

  fechaFinNueva = new Date(
    fechaFinNueva.setMonth(fechaFinNueva.getMonth() + mesesMax)
  );

  return fechaFinNueva;
};

/**
 * Sumar meses a una fecha
 */
export const addMonths = (dt, n) => {
  return new Date(dt.setMonth(dt.getMonth() + n));
};

/** formato montos dashboard */
export const number_format = (amount, decimals) => {
  amount += ""; // por si pasan un numero en vez de un string
  amount = parseFloat(amount.replace(/[^0-9\.]/g, "")); // elimino cualquier cosa que no sea numero o punto

  decimals = decimals || 0; // por si la variable no fue fue pasada

  // si no es un numero o es igual a cero retorno el mismo cero
  if (isNaN(amount) || amount === 0) return parseFloat(0).toFixed(decimals);

  // si es mayor o menor que cero retorno el valor formateado como numero
  amount = "" + amount.toFixed(decimals);

  var amount_parts = amount.split("."),
    regexp = /(\d+)(\d{3})/;

  while (regexp.test(amount_parts[0]))
    amount_parts[0] = amount_parts[0].replace(regexp, "$1" + "," + "$2");

  return amount_parts.join(".");
};

/** Para saber el color que se debe pintar las cajas del dashboard */
export const get_box_color = (titulo) => {
  let colorBox = "";
    if(titulo==='Operaciones Completadas') {
    colorBox = bgGreenHeader;
    } else if(titulo==='Operaciones con Error') {
    colorBox = bgRedHeader;
  } else if (titulo === "Total") {
    colorBox = bgGreyheader;
  } else {
    colorBox = bgBlueheader;
  }

  return colorBox;
};

/** Para saber el color que se debe pintar las cajas del dashboard (Estado de documentos) */
export const get_box_color_document = (titulo) => {
  let colorBox = "";
    if(titulo==='Archivos Parcialmente Procesados') {
    colorBox = bgGreenHeader;
    } else if(titulo==='Archivos con Error') {
    colorBox = bgRedHeader;
  } else if (titulo === "Archivos Procesados") {
    colorBox = bgGreyheader;
  } else {
    colorBox = bgBlueheader;
  }

  return colorBox;
};

/** Obtiene las opciones para un select.
 * El campo label y value varían segun el servicio invocado  **/
export const getFilterOptions = (endpoint, labelField, valueField) => {
  let optionsResponse = [];

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  fetch(endpoint, requestOptions)
    .then((result) => result.json())
    .then((response) => {
      let i = 0;
      for (i = 0; i < response.length; i++) {
        optionsResponse.push({
          label: response[i][labelField],
          value: response[i][valueField],
        });
      }
    });

  return optionsResponse;
};

/** obtener options para select estados */
export const getStatuOptions = () => {
  let optionsResponse = [];

  optionsResponse.push({
    label: "PREPARED",
    value: 1,
  });
  optionsResponse.push({
    label: "PROCESSED",
    value: 2,
  });
  optionsResponse.push({
    label: "PENDING",
    value: 3,
  });
  optionsResponse.push({
    label: "PARTIALLY_PROCESSED",
    value: 4,
  });

  return optionsResponse;
};

export const getStateOptions = (endpoint, labelField, valueField) => {
  let optionsResponse = [];
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  fetch(endpoint, requestOptions)
    .then(function (result) {
      if (result.ok) {
        result.json().then((response) => {
          let i = 0;
          for (i = 0; i < response.statusTypes.length; i++) {
            optionsResponse.push({
              label: response.statusTypes[i][labelField],
              value: response.statusTypes[i][valueField],
            });
          }
        });
      }
    })
    .catch((error) => {
      console.log("Hubo un problema con la petición Fetch:" + error.message);
    });
  return optionsResponse;
};

// Obtener filtro contexto
export const getEngineOptions = (endpoint, labelField, valueField) => {
  let optionsResponse = [];

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  fetch(endpoint, requestOptions)
    .then((result) => result.json())
    .then((response) => {
      let i = 0;
      for (i = 0; i < response.contexts.length; i++) {
        optionsResponse.push({
          label: response.contexts[i][labelField],
          value: response.contexts[i][valueField],
        });
      }
    })
    .catch((error) => {
      console.log("Hubo un problema con la petición Fetch:" + error.message);
    });

  return optionsResponse;
};

export const getTaskOptions = (endpoint) => {
  console.log(endpoint);

  let optionsResponse = [];

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  fetch(endpoint, requestOptions)
    .then((result) => result.json())
    .then((response) => {
      if (response === null || response === undefined) {
        console.log("response is null o undefined");
        return;
      }
      let i = 0;
      for (i = 0; i < response.tasks.length; i++) {
        optionsResponse.push({
          label: response.tasks[i],
          value: response.tasks[i],
        });
      }
    });

  return optionsResponse;
};

